define((require) => {
    "use strict";

    const $                  = require("jquery");
    const AbstractWidgetView = require("shared/ui/experience/widgets/AbstractWidgetView");

    /**
     * The view rendering a line widget.
     *
     * @class LineWidgetView
     * @constructor
     *
     * @cfg {LineWidgetModel} model The model of the line widget being rendered.
     */
    return AbstractWidgetView.extend("LineWidget", {

        className: `${AbstractWidgetView.prototype.className} line-widget`,

        /**
         * Move/translate the current target by x and y
         *
         * @param {Number} x1 first axis coordinate
         * @param {Number} y1 first ordinate coordinate
         * @param {Number} x2 second axis coordinate
         * @param {Number} y2 second ordinate coordinate
         *
         * @returns {jQuery} returns the jQuery element representing the line
         */
        _buildLineFromCoordinates(x1, y1, x2, y2) {
            const length = Math.sqrt(((x1 - x2) * (x1 - x2)) + ((y1 - y2) * (y1 - y2)));
            const angle  = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);
            const transform = `rotate("${angle}deg)`;
            const attr = this.model.attributes;

            const line = $("<div class ='line'>")
                .css({
                    background: attr.lineColor,
                    height: attr.lineHeight,
                    marginTop: -attr.lineHeight / 2,
                    position: "absolute",
                    transformOrigin: "0 100%",
                    width: length,
                    transform
                })
                .offset({left: x1, top: y1});

            return line;
        },

        updateRendering(element, bounds) {
            let lineFound = element.find(".line");
            const attr = this.model.attributes;

            if (lineFound.length === 0) {
                lineFound =  this._buildLineFromCoordinates(0, bounds.height / 2, bounds.width, bounds.height / 2);
                lineFound.appendTo(element);
            } else {
                lineFound.css({
                    background: attr.lineColor,
                    height: attr.lineHeight,
                    left: 0,
                    marginTop: -attr.lineHeight / 2,
                    top: bounds.height / 2,
                    width: "100%"
                });
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/lineWidget/LineWidgetView.js